import { render, staticRenderFns } from "./ClinicDocumentEdit.vue?vue&type=template&id=931e3210&scoped=true"
import script from "./ClinicDocumentEdit.vue?vue&type=script&lang=js"
export * from "./ClinicDocumentEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicDocumentEdit.vue?vue&type=style&index=0&id=931e3210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e3210",
  null
  
)

export default component.exports